module.exports = __webpack_public_path__ + "static/img/software23.bb909202.png";